import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface PageIntroProps {
  title: string;
  description: string;
  children?: ReactNode;
  className?: string;
}

export function PageIntro({
  title,
  description,
  children,
  className,
}: PageIntroProps) {
  return (
    <div
      className={cn(
        "flex flex-col gap-4 border-b border-neutral-100 pb-6 sm:flex-row sm:items-end sm:justify-between",
        className
      )}
    >
      <div className="max-w-3xl space-y-2">
        <h1 className="font-gotham text-3xl font-semibold text-neutral-900">
          {title}
        </h1>
        <p className="font-inter text-sm leading-6 text-neutral-600">
          {description}
        </p>
      </div>
      {children ? <div className="sm:shrink-0">{children}</div> : null}
    </div>
  );
}
